/**
 * Sets up cookie consent functionality.
 * When user accepts cookies, a storage key is set to "true" to prevent the consent CTA from being shown again,
 * and the article visits are initialized.
 */
import { initArticleVisits } from "./articleVisits";

export const isConsentGiven = () => {
  const consent = localStorage.getItem("cookieConsentGiven");
  return consent === "true";
};

export const initCookieConsent = () => {
  const consentCTA = document.querySelector(
    ".cta-overlay[data-variant='consent']",
  );

  if (!consentCTA) {
    return;
  }

  if (isConsentGiven()) {
    consentCTA.remove();
  } else {
    const button = document.getElementById("consent-button");
    button.addEventListener("click", () => {
      localStorage.setItem("cookieConsentGiven", "true");
      consentCTA.remove();
      initArticleVisits();
    });
  }
};
